import { defineComponent as _defineComponent } from 'vue'
import { usePagination } from '@/helpers/composables/usePagination';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';


export default /*#__PURE__*/_defineComponent({
  __name: 'PaginationNav',
  props: {
    queryParam: { default: 'page' },
    showStatus: { type: Boolean, default: true },
    showFirstJump: { type: Boolean, default: true },
    showLastJump: { type: Boolean, default: true },
    pageSize: null,
    totalCount: null,
    lastPage: null
  },
  setup(__props: any) {

const props = __props as { queryParam: string, showStatus: boolean, showFirstJump: boolean, showLastJump: boolean, pageSize: number, totalCount: number, lastPage: number };

/*
Pagination in the query is 0-based indexed but in the interface it
starts at 1 to be more intuitive for users. That's why there's so
many ±1 here :|
*/


// we don't want to display `?page=1`
function getSanitisedPage(page: number): number | undefined {
	return page > 1 ? page : undefined;
}

const { currentPage, isFirstPage } = usePagination({ lastPage: props.lastPage });

return { __sfc: true,props, getSanitisedPage, currentPage, isFirstPage, faChevronLeft, faChevronRight }
}

})